// extracted by mini-css-extract-plugin
export var dataCell = "_rh-2";
export var dataRow = "_rh-0";
export var headerRow = "_rh-1";